<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>

    <!-- 底部菜单 -->
      <kz-footer></kz-footer>
      <!-- 错误提示 -->
      <div class="warn-msg-box"></div>
  </div>
</template>

<script>
import kzFooter from './components/footer'

export default {
  name: 'App',
  provide() {
    return {
      reloads: this.reloads
    }
  },
  components: {
    kzFooter
  },
  data() {
    return {
      showFooter: true,
      isRouterAlive: true
    }
  },
  created() {
    KZ.setIpadDeviceWidth();
  },
  mounted() {
    //根据移动端返还的值判断是否是APP，以此来区别加载样式
    var isApp = sessionStorage.getItem("isApp");
    if (isApp == '1') {
      if (KZ.IsIos()) {
        $("head").append("<link rel='stylesheet' type='text/css' href='../static/css/appStyle.css'>");
      }
      if (KZ.IsAndroid()) {
        $("head").append("<link rel='stylesheet' type='text/css' href='../static/css/AndroidStyle.css'>");
      }
    }
  },
  updated() {},
  methods: {
    //声明reloads方法，控制router-view的显示或隐藏，从而控制页面的再次加载
    reloads() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    },
  },
  watch: {
    // $route(to, from) {
    //   if ( to.name != 'course' || to.name != 'study' || to.name != 'home' ) {
    //     this.showFooter = true;
    //   } else {
    //     this.showFooter = false;
    //   }
    // }
  }
}
</script>

<style>
@font-face {
  font-family: DIN-Medium;
  src: url('../static/fonts/DIN-Medium.otf');
}

body {
  margin: 0;
}

body.active-index {
  background-color: #F7F7F7
}

*,
:after,
:before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Arial, PingFang SC, Hiragino Sans GB, STHeiti, Microsoft YaHei, Microsoft JhengHei, Source Han Sans SC, Noto Sans CJK SC, Source Han Sans CN, Noto Sans SC, Source Han Sans TC, Noto Sans CJK TC, WenQuanYi Micro Hei, SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #251B18;
  font-size: 0.373333rem;
}

ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
input,
button,
p,
th,
td {
  margin: 0;
  padding: 0;
}

ol,
ul,
li {
  list-style: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
  font-size: inherit;
}

body a {
  color: #272424;
}

input {
  outline: none;
}

img {
  border: none;
  vertical-align: bottom;
}

.clearfix {
  display: inline-block;
  content: '';
  clear: both;
  width: 100%;
}

.lf {
  float: left;
}

.rt {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/App.vue